<template>
  <el-empty :style="'height:'+emptyHeight+'px'" description="页面正在开发中。。。"></el-empty>
</template>

<script>
export default {
  name: "Stations",
  data(){
    return{
      emptyHeight:1200
    }
  }
}
</script>

<style scoped>

</style>
